import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./RecruitmentCardKam.css"
import {getResource, uploadFileResource} from "../../service/http-service";
import SelectOptionTwo from "../../ui/SelectOptionTwo";
import {DatePickerComponent} from "../../ui/DatePickerComponent";

export const ModalFormSalariedKam = ({title, externalRecruitmentId, lgShow, widthClass}) => {

  const [cities, setCities] = useState([])
  const [municipalities, setMunicipalities] = useState([])
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);

  const [drivingLicences, setDrivingLicences] = useState([])
  const [educationType, setEducationType] = useState([])
  // const [educationTitle, setEducationTitle] = useState([])

  const [showError, setShowError] = useState(false)
  const [cursor, setCursor] = useState(false);
  const [modalShow, setModalShow] = useState(lgShow);

  const formDataSalaried = new FormData();

  useEffect(() => {
    getResource('cities').then((data) => {
      setCities(data.data)
    })
    getResource('municipalities').then((data) => {
      setMunicipalities(data.data)
    })
    getResource('education_types').then((data) => {
      setEducationType(data.data)
    })
    // getResource('education_fields').then((data) => {
    //     setEducationTitle(data.data)
    // })
    getResource('driving_licences').then((data) => {
      setDrivingLicences(data.data)
    })
  }, []);

  const [candidate, setCandidate] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    city: '',
    municipality: '',
    mail: '',
    drivingLicence: '',
    description: '',
    isReferral: false,
    consent: false,
    referralInfo: '',
    externalRecruitmentId: externalRecruitmentId,
    educationType: '',
    educationTitleName: '',
    educationInstitution: '',
    previousWorkingPosition: '',
    previousCompanyName: '',
    previousDateFrom: '',
    previousDateTo: null,
    additionalEducation: '',
    languages: '',
    computerSkills: ''
  })

  useEffect(() => {
    // let formDataSalaried = new formDataSalaried();
    // formDataSalaried.forEach((value, key) => {
    //     console.log("KEY1:",key,"VALUE1:", value);});

    if ((!candidate.firstName || candidate.firstName === '') ||
      (!candidate.lastName || candidate.lastName === '') ||
      (!candidate.city || candidate.city === '') ||
      (!candidate.municipality || candidate.municipality === '') ||
      (!candidate.phone || candidate.phone === '') ||
      (!candidate.mail || candidate.mail === '') ||
      (!candidate.drivingLicence || candidate.drivingLicence === '') ||
      (!candidate.educationType || candidate.educationType === '') ||
      (!candidate.educationTitleName || candidate.educationTitleName === '') ||
      (!candidate.educationInstitution || candidate.educationInstitution === '') ||
      (!candidate.previousWorkingPosition || candidate.previousWorkingPosition === '') ||
      (!candidate.previousCompanyName || candidate.previousCompanyName === '') ||
      (!candidate.previousDateFrom || candidate.previousDateFrom === '') || (!selectedFile) || (!candidate.isReferral || candidate.isReferral === false) || (!candidate.referralInfo || candidate.referralInfo === '') ||
      (!candidate.consent || candidate.consent === false)) {
      setShowError(true);
      return;
    } else if ((candidate.firstName || candidate.firstName !== '') ||
      (candidate.lastName || candidate.lastName !== '') ||
      (candidate.city || candidate.city !== '') ||
      (candidate.municipality || candidate.municipality !== '') ||
      (candidate.phone || candidate.phone !== '') ||
      (candidate.mail || candidate.mail !== '') ||
      (candidate.drivingLicence || candidate.drivingLicence !== '') ||
      (candidate.educationType || candidate.educationType !== '') ||
      (candidate.educationTitleName || candidate.educationTitleName !== '') ||
      (candidate.educationInstitution || candidate.educationInstitution !== '') ||
      (candidate.previousWorkingPosition || candidate.previousWorkingPosition !== '') ||
      (candidate.previousCompanyName || candidate.previousCompanyName !== '') ||
      (candidate.previousDateFrom || candidate.previousDateFrom !== '') || (selectedFile || true) || (candidate.isReferral || candidate.isReferral === true) || (candidate.referralInfo || candidate.referralInfo !== '') ||
      (candidate.consent || candidate.consent === true)) {
      setShowError(false);
    } else {
      setShowError(false)
    }
  }, [candidate, selectedFile])

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const clearFormFields = () => {
    setCandidate({
      externalRecruitmentId: externalRecruitmentId,
      firstName: '',
      lastName: '',
      phone: '',
      city: '',
      municipality: '',
      mail: '',
      drivingLicence: '',
      description: '',
      isReferral: false,
      consent: false,
      referralInfo: '',
      educationType: '',
      educationTitleName: '',
      educationInstitution: '',
      previousWorkingPosition: '',
      previousCompanyName: '',
      previousDateFrom: '',
      previousDateTo: '',
      additionalEducation: '',
      languages: '',
      computerSkills: ''
    })
    setModalShow(false);
  }

  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmission = () => {
    const requiredFields = [
      "firstName", "lastName", "city", "municipality", "phone", "mail",
      "drivingLicence", "educationType", "educationTitleName", "educationInstitution",
      "previousWorkingPosition", "previousCompanyName", "previousDateFrom", "consent", "isReferral","referralInfo"
    ];

    // Check for missing fields
    const missingFields = requiredFields.filter(field => !candidate[field]);
    const isFileMissing = !selectedFile;

    if (missingFields.length > 0 || isFileMissing) {
      setShowError(true);
      return;
    }

    setShowError(false);

    // Clear FormData before appending (optional but safe)
    const formDataSalaried = new FormData();

    // Append candidate fields
    for (const [key, value] of Object.entries(candidate)) {
      if (value !== undefined && value !== null) {
        formDataSalaried.append(key, value);
      }
    }

    // Append the file
    if(selectedFile!=null) {
      formDataSalaried.append("file", selectedFile);
    }

    // Upload
    uploadFileResource("candidates/add_candidate_document", formDataSalaried)
      .then((data) => {
        console.log(data.data);
        setModalShow(false);
        setSelectedFile(null);
        clearFormFields();
        alert("Вашата апликација е успешно поднесена!");
      })
      .catch((exception) => {
        alert("Настана грешка при поднесувањето на апликацијата:\n"+  exception.response.data.message);
      });
  };

  return (
    <>
      <button className={widthClass} id="apply" onClick={() => setModalShow(true)}>Аплицирај</button>
      <Modal className={cursor === false ? 'disabled' : 'cursor_wait'}
             size="lg"
             show={modalShow}
             onHide={clearFormFields}
             aria-labelledby="example-modal-sizes-title-lg"
      >

        <>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="inputs_container">
              <div className="candidate_input">
                <label>Име *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="text"
                  placeholder="Внеси име..."
                  maxLength={15}
                  value={candidate.firstName}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                    setCandidate({...candidate, firstName: value});
                  }}
                />
              </div>
              <div className="candidate_input">
                <label>Презиме *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="text"
                  placeholder="Внеси презиме..."
                  maxLength={15}
                  value={candidate.lastName}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                    setCandidate({...candidate, lastName: value});
                  }}
                />
              </div>
              <div className="candidate_input">
                <label>Телефон *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="number"
                  placeholder="Внеси телефон..."
                  maxLength={15}
                  value={candidate.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9+\s]/g, ""); // allows numbers, and +
                    setCandidate({...candidate, phone: value});
                  }}
                />
              </div>
              <div className="candidate_input">
                <label>Град *</label>
                <br/>
                {(cities && cities.length > 0) &&
                  <SelectOptionTwo
                    placeholder={"Внеси град..."}
                    value={candidate.city ? candidate.city : ""}
                    data={cities}
                    handleChange={(selectedOption) => {
                      setCandidate({
                        ...candidate,
                        city: selectedOption ? selectedOption.value : ""
                      })
                    }}
                  />
                }
              </div>
              <div className="candidate_input">
                <label>Општина *</label>
                <br/>
                {(municipalities && municipalities.length > 0) &&
                  <SelectOptionTwo
                    placeholder={"Внеси општина..."}
                    value={candidate.municipality ? candidate.municipality : ""}
                    data={municipalities}
                    handleChange={(selectedOption) => {
                      setCandidate({
                        ...candidate,
                        municipality: selectedOption ? selectedOption.value : ""
                      })
                    }}
                  />
                }
              </div>
              <div className="candidate_input">
                <label>E-mail *</label>
                <br/>
                <>
                  <input
                    className="candidate_data"
                    type="email"
                    placeholder="Внеси e-mail..."
                    value={candidate.mail}
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9@._%+-]/g, "");
                      setCandidate({...candidate, mail: value});

                      // Show message instantly
                      if (value && !validateEmail(value)) {
                        setEmailError("Внесете валидна e-mail адреса");
                      } else {
                        setEmailError("");
                      }
                    }}
                  />
                  {emailError && <span style={{color: "red"}}>{emailError}</span>}
                </>
              </div>
              <div className="candidate_input">
                <label>Возачка дозвола *</label>
                <br/>
                {(drivingLicences && drivingLicences.length > 0) &&
                  <SelectOptionTwo
                    placeholder={"Внеси возачка дозвола..."}
                    value={candidate.drivingLicence ? candidate.drivingLicence : ""}
                    data={drivingLicences}
                    handleChange={(selectedOption) => {
                      setCandidate({
                        ...candidate,
                        drivingLicence: selectedOption ? selectedOption.value : ""
                      })
                    }}
                  />
                }
              </div>
            </div>
            <br/>
            <h5> Образование</h5>
            <div className="inputs_container">
              <div className="candidate_input">
                <label>Степен на образование *</label>
                <br/>
                {(educationType && educationType.length > 0) &&
                  (
                    <SelectOptionTwo
                      placeholder="Степен на образование"
                      value={candidate.educationType ? candidate.educationType : ""}
                      data={educationType}
                      handleChange={(selectedOption) => {
                        setCandidate({
                          ...candidate,
                          educationType: selectedOption ? selectedOption.value : ""
                        })
                      }}
                    />)}
              </div>
              <div className="candidate_input">
                <label>Насока на образование *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="text"
                  placeholder="Внеси насока..."
                  maxLength={30}
                  required
                  value={candidate.educationTitleName}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш.\s]/g, ""); // allows letters (Latin/Cyrillic) and .
                    setCandidate({...candidate, educationTitleName: value});
                  }}
                />
                {/*{(educationTitle && educationTitle.length > 0) &&*/}
                {/*    (*/}
                {/*        <SelectOptionTwo*/}
                {/*            placeholder="Насока на образование"*/}
                {/*            value={candidate.educationTitle ? candidate.educationTitle : ""}*/}
                {/*            data={educationTitle}*/}
                {/*            handleChange={(selectedOption) => {*/}
                {/*                setCandidate({*/}
                {/*                    ...candidate,*/}
                {/*                    educationTitle: selectedOption ? selectedOption.value : ""*/}
                {/*                })*/}
                {/*            }}*/}
                {/*        />)}*/}
              </div>
              <div className="inputs_container">
                <label>Образовна институција *</label>
                <br/>
                <textarea
                  className="candidate_textarea"
                  type="text"
                  placeholder="Внеси институција..."
                  maxLength={30}
                  required
                  value={candidate.educationInstitution}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш.\s]/g, ""); // allows letters (Latin/Cyrillic) and .
                    setCandidate({...candidate, educationInstitution: value});
                  }}
                />
              </div>
            </div>
            <br/>
            <h5>Последно работно искуство</h5>
            <div className="inputs_container">
              <div className="candidate_input">
                <label>Работна позиција *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="text"
                  placeholder="Внеси работна позиција..."
                  maxLength={20}
                  required
                  value={candidate.previousWorkingPosition}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic) and .
                    setCandidate({...candidate, previousWorkingPosition: value});
                  }}
                />
              </div>
              <div className="candidate_input">
                <label>Компанија *</label>
                <br/>
                <input
                  className="candidate_data"
                  type="text"
                  placeholder="Внеси име на компанија..."
                  maxLength={20}
                  required
                  value={candidate.previousCompanyName}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш\s]/g, ""); // allows letters (Latin/Cyrillic) and .
                    setCandidate({...candidate, previousCompanyName: value});
                  }}
                />
              </div>
              <div className="candidate_input">
                <label>Датум на почеток *</label>
                <DatePickerComponent
                  selectedDate={candidate.previousDateFrom}
                  onChange={(e) => {
                    setCandidate({...candidate, previousDateFrom: e})
                  }}
                  placeholder="Датум на почеток"/>
              </div>
              <div className="candidate_input">
                <label>Датум на престанок</label>
                <DatePickerComponent
                  selectedDate={candidate.previousDateTo}
                  onChange={(e) => {
                    setCandidate({...candidate, previousDateTo: e})
                  }}
                  placeholder="Датум на престанок"/>
              </div>
            </div>
            <br/>
            <div>
              <form id="newDocForm" className="d-flex justify-content-start">
                <br/>
                <label className="w-25">Прикачи CV *</label>
                <input
                  type="file"
                  formtype="multipart/form-data"
                  onChange={(e) => changeHandler(e)}/>
              </form>
            </div>
            <br/>
            <h5>Останато</h5>
            <div>
              <label>Неформално образование</label>
              <br/>
              <textarea
                className="candidate_textarea"
                type="text"
                placeholder="Внеси курсеви, сертификати..."
                maxLength={200}
                value={candidate.additionalEducation}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                  setCandidate({...candidate, additionalEducation: value});
                }}
              />
              <div style={{fontSize: "12px",
                float: "right",
                color: candidate.additionalEducation.length >= 200 ? "red" : "#666"}}>
                {candidate.additionalEducation.length}/200
              </div>
            </div>
            <div>
              <label>Јазици и степен на познавање</label>
              <br/>
              <textarea
                className="candidate_textarea"
                type="text"
                placeholder="Внеси јазици (почетно/средно/напредно ниво)"
                maxLength={150}
                value={candidate.languages}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                  setCandidate({...candidate, languages: value});
                }}
              />
              <div style={{fontSize: "12px",
                float: "right",
                color: candidate.languages.length >= 150 ? "red" : "#666"}}>
                {candidate.languages.length}/150
              </div>
            </div>
            <div>
              <label>Компјутерски вештини и степен на познавање</label>
              <br/>
              <textarea
                className="candidate_textarea"
                type="text"
                placeholder="Внеси компјутерски вештини (почетно/средно/напредно ниво)"
                maxLength={150}
                value={candidate.computerSkills}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                  setCandidate({...candidate, computerSkills: value});
                }}
              />
              <div style={{fontSize: "12px",
                float: "right",
                color: candidate.computerSkills.length >= 150 ? "red" : "#666"}}>
                {candidate.computerSkills.length}/150
              </div>
            </div>
            <div>
              <label>Опиши се себеси</label>
              <br/>
              <textarea
                className="candidate_textarea"
                type="text"
                placeholder="Опиши се себеси..."
                maxLength={200}
                value={candidate.description}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, ""); // allows letters (Latin/Cyrillic), numbers, and space
                  setCandidate({...candidate, description: value});
                }}
              />
              <div style={{fontSize: "12px",
                float: "right",
                color: candidate.description.length >= 200 ? "red" : "#666"}}>
                {candidate.description.length}/200
              </div>
            </div>
            <div className="referral">
              <input type="checkbox" id="referral" name="referral"
                     value={candidate.isReferral}
                     onClick={(e) => setCandidate({...candidate, isReferral: !candidate.isReferral})}/>
              <label htmlFor="referral"> * Препорачано од пријател</label>
            </div>
            {candidate.isReferral &&
              <div>
                                <textarea
                                  className="candidate_textarea mt-2"
                                  type="text"
                                  placeholder="Препорачано од пријател (да се наведе име, презиме, работна позиција)..."
                                  maxLength={50}
                                  required
                                  value={candidate.referralInfo}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^a-zA-Zа-шА-Ш0-9.,\s]/g, "");
                                    setCandidate({...candidate, referralInfo: value});
                                  }}
                                />
                <div style={{fontSize: "12px",
                  float: "right",
                  color: candidate.referralInfo.length >= 50 ? "red" : "#666"}}>
                  {candidate.referralInfo.length}/50
                </div>

              </div>}


            <div style={{marginTop: "15px"}}>
              <input type="checkbox" id="consent" name="consent"
                     value={candidate.consent}
                     onClick={(e) => setCandidate({...candidate, consent: !candidate.consent})}/>
              <label style={{display: "inline"}} htmlFor="consent"> * Давам изречна согласност КАМ доо Илинден, да врши
                обработка на моите лични податоци,
                како и да ги чува во збирката на лични податоци, за потребите на процесот на регрутација на кадри во
                Друштвото се додека има потреба од истите и да постапува со нив согласно Законот за заштита на личните
                податоци и <a
                  href="https://kam.com.mk/politika-za-zashtita-na-licni-podatoci.nspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Политиката за заштита на лични податоци
                </a></label>
            </div>
          </Modal.Body>
          <Modal.Footer closeButton>
            {showError && <small className="color_red">Ве молиме пополнете ги задолжителните * полиња</small>}
            <div
              type="button"
              className={`btn_apply_form ${((!candidate.firstName)
                || (!candidate.lastName)
                || (!candidate.city)
                || (!candidate.municipality)
                || (!candidate.phone)
                || (!candidate.mail)
                || (!candidate.drivingLicence)
                || (!candidate.educationType)
                || (!candidate.educationTitleName)
                || (!candidate.educationInstitution)
                || (!candidate.previousWorkingPosition)
                || (!candidate.previousCompanyName)
                || (!candidate.previousDateFrom)
                || (!selectedFile)
                || (!candidate.isReferral)
                || (!candidate.referralInfo)
                || (!candidate.consent)) ? 'disabled' : ''}`}
              onClick={(e) => handleSubmission()}
              disabled={(!candidate.firstName)
                || (!candidate.lastName)
                || (!candidate.city)
                || (!candidate.municipality)
                || (!candidate.phone)
                || (!candidate.mail)
                || (!candidate.drivingLicence)
                || (!candidate.educationType)
                || (!candidate.educationTitleName)
                || (!candidate.educationInstitution)
                || (!candidate.previousWorkingPosition)
                || (!candidate.previousCompanyName)
                || (!candidate.previousDateFrom)
                || (!selectedFile)
                || (!candidate.isReferral)
                || (!candidate.referralInfo)
                || (!candidate.consent)}
            >
              Аплицирај
            </div>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );

}

export default ModalFormSalariedKam;
